import { useState } from "react";
import { DataTable } from "../../components/DataTable";
import { useAuth } from "../../context/AuthContext";
import { materialService } from "../../services/materialsService";
import { useEffect } from "react";
import { materialTypeService } from "../../services/materialTypeService";
import { MaterialType } from "../../interfaces/MaterialType";
import { useMemo } from "react";
import {
  Material,
  CreateMaterialRequest,
  ApiResponse
} from "../../interfaces/Material";
// type Material = {
//   id: string;
//   name: string;
//   slug: string;
//   type: string;
//   description: string;
//   status: "Active" | "Hidden";
//   metaTitle: string;
//   metaDescription: string;
//   metaKeywords: string;
//   canonicalUrl: string;
//   ogTitle: string;
//   ogDescription: string;
//   ogImage: string;
//   createdAt: string;
// };

const materialTypeMap: Record<string, number> = {
  Metal: 1,
  Gemstone: 2,
  Fabric: 3,
  Wood: 4,
  Leather: 5,
  Glass: 6,
  Ceramic: 7,
  Other: 8
};
export function CreateMaterialPage() {
  const { user } = useAuth();
  const canManage = user?.role === "admin";

  const [name, setName] = useState("");
  const [slug, setSlug] = useState("");
  const [type, setType] = useState<number | "">("");
  const [description, setDescription] = useState("");
  const [status, setStatus] = useState<"Active" | "Hidden">("Active");
  const [metaTitle, setMetaTitle] = useState("");
  const [metaDesc, setMetaDesc] = useState("");
  const [metaKeys, setMetaKeys] = useState("");
  const [canonicalUrl, setCanonicalUrl] = useState("");
  const [ogTitle, setOgTitle] = useState("");
  const [ogDesc, setOgDesc] = useState("");
  const [ogImage, setOgImage] = useState("");
  const [saved, setSaved] = useState(false);
  const [materials, setMaterials] = useState<Material[]>([]);
  const [loading, setLoading] =
    useState(false);

  const [editingId, setEditingId] = useState<string | null>(null);
  const [editForm, setEditForm] = useState<Partial<Material>>({});
  const [materialTypes, setMaterialTypes] = useState<MaterialType[]>([]);

  const [editingMaterialId, setEditingMaterialId] =
    useState<number | null>(null);

  const [viewMaterial, setViewMaterial] =
    useState<Material | null>(null);
  const [deleteConfirmId, setDeleteConfirmId] =
    useState<number | null>(null);

  const [infoModal, setInfoModal] =
    useState<{ msg: string; type: "success" | "error" | "warn" } | null>(null);
  const materialTypeNameMap = useMemo(() => {
  return Object.fromEntries(
    materialTypes.map(t => [t.materialTypeID, t.materialTypeName])
  );
}, [materialTypes]);
  function handleNameChange(val: string) {
    setName(val);
    setSlug(val.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, ""));
  }
function isDuplicateName(name: string, id?: number | null) {
  return materials.some(m =>
    m.materialName.toLowerCase().trim() === name.toLowerCase().trim() &&
    m.materialID !== id // allow same name for edit case
  );
}
  useEffect(() => {
    loadMaterialTypes();
  }, []);

  async function loadMaterialTypes() {
    try {
      const res = await materialTypeService.getAll();
      setMaterialTypes(res.dataList || []);
    } catch (err) {
      console.error(err);
    }
  }
  useEffect(() => {
    loadMaterials();
  }, []);

  async function loadMaterials() {
    try {
      setLoading(true);
      const data = await materialService.getAll();
      console.log("Materials API Response:", data); // 👈 add this
      setMaterials(data); // ✅ FIXED
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }
  async function handleSubmit() {
    if (!name.trim()) return;
 if (isDuplicateName(name, editingMaterialId)) {
    setInfoModal({ msg: "Material name already exists!", type: "warn" });
    return;
  }

    try {
      const payload = {
        materialName: name.trim(),
        materialSlug: slug,
        description,
        materialTypeID: typeof type === "number" ? type : 0,

        status,

        metaTitle: metaTitle || `${name.trim()} Jewellery Material | NineSisters`,
        metaDescription: metaDesc,
        metaKeywords: metaKeys,
        canonicalUrl,

        ogTitle: ogTitle || metaTitle || name.trim(),
        ogDescription: ogDesc || metaDesc,
        schemaMarkup: "",

        ogImage: null
      };
      let response;

      if (editingMaterialId !== null) {
        response = await materialService.update({
          materialID: editingMaterialId,
          ...payload
        });
      } else {
        response = await materialService.create(payload);
      }

      if (response?.isSuccess) {
        // const newMaterial = response.data;

        // setMaterials(prev => [newMaterial, ...prev]);

        await loadMaterials();
        setInfoModal({
          msg: editingMaterialId
            ? "Material updated successfully!"
            : "Material created successfully!",
          type: "success"
        });
        setEditingMaterialId(null);
        resetForm();
        loadMaterials();
        setSaved(true);
        setTimeout(() => setSaved(false), 3000);

        resetForm();
      } else {
        setInfoModal({ msg: response?.message || "Failed to create material", type: "error" });
      }

    } catch (error: any) {
      console.error("Create Material Error:", error);
      setInfoModal({ msg: error?.message || "Something went wrong", type: "error" });
    }
  }
  async function deleteMaterial() {
    if (!deleteConfirmId) return;

    try {
      const response = await materialService.delete(deleteConfirmId);

      setInfoModal({ msg: response.message || "Deleted successfully", type: "success" });

      await loadMaterials();

      setDeleteConfirmId(null);
    } catch (error: any) {
      console.error(error);
      setInfoModal({ msg: error?.message || "Error deleting material", type: "error" });
    }
  }
  function resetForm() {
    setName("");
    setSlug("");
    setType("");
    setDescription("");
    setStatus("Active");

    setMetaTitle("");
    setMetaDesc("");
    setMetaKeys("");
    setCanonicalUrl("");

    setOgTitle("");
    setOgDesc("");
    setOgImage("");
  }

  // function deleteItem(id: string) { setMaterials(prev => prev.filter(m => m.id !== id)); }
  // function startEdit(m: Material) { setEditingId(m.materialID); setEditForm({ ...m }); }
  // function saveEdit(id: string) { setMaterials(prev => prev.map(m => m.id === id ? { ...m, ...editForm } as Material : m)); setEditingId(null); setEditForm({}); }
  // function cancelEdit() { setEditingId(null); setEditForm({}); }
  async function toggleStatus(id: number) {
    const material = materials.find(m => m.materialID === id);
    if (!material) return;

    try {
      await materialService.update({
        materialID: material.materialID,
        materialName: material.materialName,
        materialSlug: material.materialSlug,
        description: material.description,
        materialTypeID: material.materialTypeID,
        status: material.status === "Active" ? "Hidden" : "Active",

        metaTitle: material.metaTitle,
        metaDescription: material.metaDescription,
        metaKeywords: material.metaKeywords,
        canonicalUrl: material.canonicalUrl,
        ogTitle: material.ogTitle,
        ogDescription: material.ogDescription,
        schemaMarkup: material.schemaMarkup
      });

      await loadMaterials();
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className="d-grid gap-4">
      <div className="card border-0 shadow-sm mst-card">
        <div className="card-body p-4">
          <div className="d-flex align-items-center gap-2 mb-4">
            <div className="mst-icon-box"><i className="bi bi-layers"></i></div>
            <div>
              <h5 className="mb-0 fw-bold mst-title">Create Material</h5>
              <small className="mst-subtitle">Add a new material type used in jewellery</small>
            </div>
          </div>

          {saved && (
            <div className="alert alert-success d-flex align-items-center gap-2 py-2 mb-3 mst-alert">
              <i className="bi bi-check-circle-fill"></i> Material saved successfully!
            </div>
          )}

          <div className="row g-3">
            <div className="col-md-6">
              <label className="form-label fw-semibold mst-label">Material Name <span className="text-danger">*</span></label>
              <input className="form-control mst-control" placeholder="e.g. Gold, Silver, Diamond"
                value={name} onChange={e => handleNameChange(e.target.value)} />
            </div>

            <div className="col-md-6">
              <label className="form-label fw-semibold mst-label">Slug (auto-generated)</label>
              <div className="input-group">
                <span className="input-group-text mst-ig-text">/material/</span>
                <input className="form-control mst-control-right" placeholder="gold"
                  value={slug} onChange={e => setSlug(e.target.value)} />
              </div>
            </div>
          <div className="col-md-6">
  <label className="form-label fw-semibold mst-label">
    Material Type
  </label>

  <select
    className="form-select mst-select"
    value={type}
    onChange={e =>
      setType(e.target.value ? Number(e.target.value) : "")
    }
  >
    <option value="">Select type...</option>

    {materialTypes.map((t) => (
      <option key={t.materialTypeID} value={t.materialTypeID}>
        {t.materialTypeName}
      </option>
    ))}
  </select>      
</div>
            <div className="col-md-6">
              <label className="form-label fw-semibold mst-label">Status</label>
              <select className="form-select mst-select" value={status}
                onChange={e => setStatus(e.target.value as "Active" | "Hidden")}>
                <option value="Active">Active</option>
                <option value="Hidden">Hidden</option>
              </select>
            </div>
            <div className="col-12">
              <label className="form-label fw-semibold mst-label">Description</label>
              <textarea className="form-control mst-textarea" placeholder="Describe this material..." rows={3}
                value={description} onChange={e => setDescription(e.target.value)} />
            </div>

            <div className="col-12 mt-2">
              <div className="mst-seo-divider"><i className="bi bi-search me-2"></i>SEO & Meta Settings</div>
            </div>
            <div className="col-12">
              <div className="mst-seo-hint"><i className="bi bi-info-circle me-1"></i>These fields control how this material page appears in Google search results and social media.</div>
            </div>
            <div className="col-md-8">
              <label className="form-label fw-semibold mst-label">Meta Title <span className="mst-seo-counter">{metaTitle.length}/60</span></label>
              <input className="form-control mst-control" placeholder="e.g. Gold Jewellery | NineSisters" maxLength={60}
                value={metaTitle} onChange={e => setMetaTitle(e.target.value)} />
            </div>
            <div className="col-md-4">
              <label className="form-label fw-semibold mst-label">Meta Keywords</label>
              <input className="form-control mst-control" placeholder="e.g. gold, 22K, jewellery"
                value={metaKeys} onChange={e => setMetaKeys(e.target.value)} />
            </div>
            <div className="col-12">
              <label className="form-label fw-semibold mst-label">Meta Description <span className="mst-seo-counter">{metaDesc.length}/160</span></label>
              <textarea className="form-control mst-textarea" placeholder="Brief summary shown in search results — 120–160 characters recommended" rows={2} maxLength={160}
                value={metaDesc} onChange={e => setMetaDesc(e.target.value)} />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold mst-label">Canonical URL <span className="mst-seo-opt">(optional)</span></label>
              <input className="form-control mst-control" placeholder="https://ninesistersjewels.com/material/..."
                value={canonicalUrl} onChange={e => setCanonicalUrl(e.target.value)} />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold mst-label">OG Image URL <span className="mst-seo-opt">(Social share image)</span></label>
              <input className="form-control mst-control" placeholder="https://..."
                value={ogImage} onChange={e => setOgImage(e.target.value)} />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold mst-label">OG Title <span className="mst-seo-opt">(optional)</span></label>
              <input className="form-control mst-control" placeholder="Social media share title"
                value={ogTitle} onChange={e => setOgTitle(e.target.value)} />
            </div>
            <div className="col-md-6">
              <label className="form-label fw-semibold mst-label">OG Description <span className="mst-seo-opt">(optional)</span></label>
              <input className="form-control mst-control" placeholder="Social media preview description"
                value={ogDesc} onChange={e => setOgDesc(e.target.value)} />
            </div>
          </div>

          <div className="d-flex gap-2 mt-4">
            <button type="button" className="btn btn-primary px-4 mst-btn-save"
              onClick={handleSubmit} disabled={!name.trim()}>
              <i className="bi bi-plus-circle me-2"></i>
              {editingMaterialId ? "Update Material" : "Save Material"}
            </button>
            <button type="button" className="btn mst-btn-reset"
              onClick={() => { setName(""); setSlug(""); setType(""); setDescription(""); setStatus("Active"); setMetaTitle(""); setMetaDesc(""); setMetaKeys(""); setCanonicalUrl(""); setOgTitle(""); setOgDesc(""); setOgImage(""); }}>
              Reset
            </button>
          </div>
        </div>
      </div>

      {/* <DataTable<Material>
        title="Materials"
        rows={materials}
        rowKey={r => r.id}
        searchPlaceholder="Search materials..."
        exportFileName="materials"
        columns={[
          { key: "name", label: "Material", sortable: true,
            render: r => editingId === r.id
              ? <input className="form-control form-control-sm" value={editForm.name ?? ""} onChange={e => setEditForm(f => ({ ...f, name: e.target.value }))} />
              : <span className="fw-semibold">{r.name}</span>
          },
          { key: "slug", label: "Slug", render: r => <code className="mst-code">{r.slug}</code> },
          { key: "type", label: "Type",
            render: r => r.type
              ? <span className="badge text-bg-secondary">{r.type}</span>
              : <span className="mst-smoke">—</span>
          },
          { key: "status", label: "Status",
            render: r => <span className={`badge ${r.status === "Active" ? "text-bg-success" : "text-bg-secondary"}`}>{r.status}</span>
          },
          { key: "createdAt", label: "Created", sortable: true },
          ...(canManage ? [{
            key: "actions" as const, label: "Actions", className: "text-end",
            render: (r: Material) => editingId === r.id ? (
              <div className="pg-actions">
                <button type="button" className="btn btn-sm btn-success" onClick={() => saveEdit(r.id)}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                </button>
                <button type="button" className="btn btn-sm btn-outline-secondary" onClick={cancelEdit}>
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                </button>
              </div>
            ) : (
              <div className="pg-actions">
                <button type="button" className="btn btn-sm btn-outline-primary mst-btn-status" onClick={() => startEdit(r)} title="Edit">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                </button>
                <button type="button" className="btn btn-sm btn-outline-secondary mst-btn-status" onClick={() => toggleStatus(r.id)}>
                  {r.status === "Active" ? "Hide" : "Show"}
                </button>
                <button type="button" className="btn btn-sm btn-outline-danger mst-btn-delete" onClick={() => deleteItem(r.id)}>
                  <i className="bi bi-trash"></i>
                </button>
              </div>
            ),
          }] : []),
        ]}
      /> */}
      <DataTable<Material>
        rows={materials}
        rowKey={r => r.materialID.toString()}
        columns={[

          {
            key: "materialName",
            label: "Material",
            render: r => (
              <span className="fw-semibold">
                {r.materialName}
              </span>
            )
          },

          {
            key: "materialSlug",
            label: "Slug",
            render: r => <code>{r.materialSlug}</code>
          },

          {
            key: "materialTypeID",
            label: "Type",
            render: r =>
              r.materialTypeID ? (
                <span className="badge text-bg-secondary">
                  {materialTypeNameMap[r.materialTypeID] || "Unknown"}
                </span>
              ) : (
                <span>—</span>
              )
          },

          {
            key: "status",
            label: "Status",
            render: r => (
              <span
                className={`badge ${r.status === "Active"
                    ? "text-bg-success"
                    : "text-bg-secondary"
                  }`}
              >
                {r.status}
              </span>
            )
          },

          {
            key: "createdDate",
  label: "Created",
  render: r =>
    r.createdDate
      ? materialService.formatDateTime(r.createdDate)
      : "-"
          },

          {
            key: "actions",
            label: "Actions",
            render: r => (
              <div className="d-flex gap-2">

                <button
                  className="btn btn-info btn-sm"
                  onClick={() => setViewMaterial(r)}
                >
                  <i className="bi bi-eye"></i>
                </button>

                <button
                  className="btn btn-primary btn-sm"
                  onClick={() => {
                    setEditingMaterialId(r.materialID);

                    setName(r.materialName);
                    setSlug(r.materialSlug);
                    setType(r.materialTypeID!);
                    setDescription(r.description || "");
                    setStatus((r.status as any) || "Active");

                    setMetaTitle(r.metaTitle || "");
                    setMetaDesc(r.metaDescription || "");
                    setMetaKeys(r.metaKeywords || "");
                    setCanonicalUrl(r.canonicalUrl || "");

                    setOgTitle(r.ogTitle || "");
                    setOgDesc(r.ogDescription || "");
                    setOgImage(r.ogImage || "");
                  }}
                >
                  <i className="bi bi-pencil-square"></i>
                </button>

                <button
                  className="btn btn-warning btn-sm"
                  onClick={() => toggleStatus(r.materialID)}
                >
                  Toggle
                </button>

                
                 {/* DELETE */}
{Boolean(r.isActive) && (

  <button
    className="btn btn-danger btn-sm"
    onClick={() =>
      setDeleteConfirmId(
        r.materialID
      )
    }
  >
    <i className="bi bi-trash"></i>
  </button>

)}

              </div>
            )
          }
        ]}
      />

      {/* ========================================= */}
      {/* DELETE CONFIRM MODAL */}
      {/* ========================================= */}

      {deleteConfirmId && (

        <div
          className="pm-del-overlay"
          onClick={(e) => {

            if (e.target === e.currentTarget) {

              setDeleteConfirmId(null);
            }
          }}
        >

          <div className="pm-del-box">

            <div className="pm-del-ico">

              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#ef4444"
                strokeWidth="2.5"
              >
                <polyline points="3 6 5 6 21 6" />

                <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />

                <path d="M10 11v6" />

                <path d="M14 11v6" />
              </svg>

            </div>

            <div className="pm-del-title">
              Delete Material?
            </div>

            <div className="pm-del-sub">
              This action cannot be undone.
              The Material will be permanently removed.
            </div>

            <div className="pm-del-btns">

              <button
                className="pm-btn-ghost"
                onClick={() =>
                  setDeleteConfirmId(null)
                }
                type="button"
              >
                Cancel
              </button>

              <button
                className="pm-btn-danger"
                onClick={deleteMaterial}
                type="button"
              >
                Delete
              </button>

            </div>

          </div>

        </div>
      )}

      {/* ========================================= */}
      {/* VIEW MODAL */}
      {/* ========================================= */}

      {viewMaterial && (
        <div
          className="ns-overlay"
          onClick={(e) => {
            if (e.target === e.currentTarget) setViewMaterial(null);
          }}
        >
          <div className="ns-modal" style={{ maxWidth: 640 }}>

            {/* HEADER */}
            <div className="ns-modal-head">
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: 10,
                  background: "linear-gradient(135deg,#3b82f6,#8b5cf6)",
                  display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0,
                }}>
                  <i className="bi bi-layers" style={{ color: "#fff", fontSize: 16 }}></i>
                </div>
                <div>
                  <div className="ns-modal-title">Material Details</div>
                  <div style={{ fontSize: 12, color: "#94a3b8", marginTop: 1 }}>ID #{viewMaterial.materialID}</div>
                </div>
              </div>
              <button className="ns-modal-close" onClick={() => setViewMaterial(null)}>✕</button>
            </div>

            {/* BODY */}
            <div className="ns-modal-body">

              {/* BANNER */}
              <div style={{
                display: "flex", alignItems: "center", gap: 16, padding: "16px",
                background: "linear-gradient(135deg,#eff6ff,#f5f3ff)",
                borderRadius: 12, marginBottom: 20, border: "1px solid #dbeafe",
              }}>
                <div style={{
                  width: 72, height: 72, borderRadius: 12, flexShrink: 0,
                  background: "linear-gradient(135deg,#3b82f6,#8b5cf6)",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  boxShadow: "0 4px 12px rgba(59,130,246,.25)",
                }}>
                  <i className="bi bi-layers" style={{ color: "#fff", fontSize: 28 }}></i>
                </div>
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontWeight: 700, fontSize: 17, color: "#1e293b", marginBottom: 4 }}>
                    {viewMaterial.materialName}
                  </div>
                  <code style={{ fontSize: 12, color: "#8b5cf6", background: "#f3e8ff", padding: "2px 8px", borderRadius: 6 }}>
                    /material/{viewMaterial.materialSlug}
                  </code>
                  <div style={{ display: "flex", gap: 8, marginTop: 8, flexWrap: "wrap" }}>
                    <span style={{
                      display: "inline-flex", alignItems: "center", gap: 4,
                      padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 700,
                      background: viewMaterial.status === "Active" ? "#dcfce7" : "#f1f5f9",
                      color: viewMaterial.status === "Active" ? "#166534" : "#475569",
                    }}>
                      <span style={{
                        width: 6, height: 6, borderRadius: "50%",
                        background: viewMaterial.status === "Active" ? "#22c55e" : "#94a3b8",
                        display: "inline-block"
                      }}></span>
                      {viewMaterial.status}
                    </span>
                    {viewMaterial.materialTypeID && materialTypeNameMap[viewMaterial.materialTypeID] && (
                      <span style={{ padding: "3px 10px", borderRadius: 20, fontSize: 11, fontWeight: 600, background: "#e0e7ff", color: "#3730a3" }}>
                        {materialTypeNameMap[viewMaterial.materialTypeID]}
                      </span>
                    )}
                  </div>
                </div>
              </div>

              {/* DESCRIPTION */}
              {viewMaterial.description && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6 }}>Description</div>
                  <div style={{ fontSize: 13, color: "#475569", background: "#f8fafc", borderRadius: 10, padding: "10px 14px", border: "1px solid #f1f5f9", lineHeight: 1.6 }}>
                    {viewMaterial.description}
                  </div>
                </div>
              )}

              {/* SEO SECTION */}
              {(viewMaterial.metaTitle || viewMaterial.metaDescription || viewMaterial.metaKeywords || viewMaterial.canonicalUrl) && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1, marginBottom: 10, display: "flex", alignItems: "center", gap: 6 }}>
                    <i className="bi bi-search" style={{ fontSize: 12 }}></i> SEO Settings
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    {[
                      { label: "Meta Title",       value: viewMaterial.metaTitle },
                      { label: "Meta Keywords",    value: viewMaterial.metaKeywords },
                      { label: "Canonical URL",    value: viewMaterial.canonicalUrl, full: true },
                      { label: "Meta Description", value: viewMaterial.metaDescription, full: true },
                    ].filter(f => f.value).map(field => (
                      <div key={field.label} style={{ gridColumn: field.full ? "1 / -1" : undefined, background: "#f8fafc", borderRadius: 10, padding: "10px 14px", border: "1px solid #f1f5f9" }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: .5, marginBottom: 3 }}>{field.label}</div>
                        <div style={{ fontSize: 13, color: "#334155", wordBreak: "break-word" }}>{field.value}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* OG SECTION */}
              {(viewMaterial.ogTitle || viewMaterial.ogDescription) && (
                <div style={{ marginBottom: 20 }}>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1, marginBottom: 10, display: "flex", alignItems: "center", gap: 6 }}>
                    <i className="bi bi-share" style={{ fontSize: 12 }}></i> Open Graph
                  </div>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10 }}>
                    {[
                      { label: "OG Title",       value: viewMaterial.ogTitle },
                      { label: "OG Description", value: viewMaterial.ogDescription, full: true },
                    ].filter(f => f.value).map(field => (
                      <div key={field.label} style={{ gridColumn: field.full ? "1 / -1" : undefined, background: "#f8fafc", borderRadius: 10, padding: "10px 14px", border: "1px solid #f1f5f9" }}>
                        <div style={{ fontSize: 10, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: .5, marginBottom: 3 }}>{field.label}</div>
                        <div style={{ fontSize: 13, color: "#334155" }}>{field.value}</div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* SCHEMA MARKUP */}
              {viewMaterial.schemaMarkup && (
                <div>
                  <div style={{ fontSize: 11, fontWeight: 700, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 1, marginBottom: 6, display: "flex", alignItems: "center", gap: 6 }}>
                    <i className="bi bi-code-slash" style={{ fontSize: 12 }}></i> Schema Markup
                  </div>
                  <pre style={{
                    background: "#0f172a", color: "#e2e8f0", borderRadius: 10,
                    padding: "14px 16px", fontSize: 12, whiteSpace: "pre-wrap",
                    wordBreak: "break-word", margin: 0, maxHeight: 160, overflowY: "auto",
                  }}>
                    {viewMaterial.schemaMarkup}
                  </pre>
                </div>
              )}
            </div>

            {/* FOOTER */}
            <div className="ns-modal-foot">
              <button
                type="button"
                onClick={() => setViewMaterial(null)}
                style={{
                  background: "#f8fafc",
                  color: "#475569",
                  border: "1.5px solid #e2e8f0",
                  borderRadius: 10,
                  padding: "9px 20px",
                  fontSize: 13,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                }}
              >
                Close
              </button>
              <button
                type="button"
                onClick={() => {
                  const r = viewMaterial;
                  setEditingMaterialId(r.materialID);
                  setName(r.materialName);
                  setSlug(r.materialSlug);
                  setType(r.materialTypeID!);
                  setDescription(r.description || "");
                  setStatus((r.status as any) || "Active");
                  setMetaTitle(r.metaTitle || "");
                  setMetaDesc(r.metaDescription || "");
                  setMetaKeys(r.metaKeywords || "");
                  setCanonicalUrl(r.canonicalUrl || "");
                  setOgTitle(r.ogTitle || "");
                  setOgDesc(r.ogDescription || "");
                  setOgImage(r.ogImage || "");
                  setViewMaterial(null);
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }}
                style={{
                  background: "linear-gradient(135deg,#3b82f6,#8b5cf6)",
                  color: "#fff",
                  border: "none",
                  borderRadius: 10,
                  padding: "9px 20px",
                  fontSize: 14,
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 6,
                  boxShadow: "0 2px 8px rgba(59,130,246,.35)",
                }}
              >
                <i className="bi bi-pencil-square"></i>
                Edit Material
              </button>
            </div>

          </div>
        </div>
      )}

      {/* ========================================= */}
      {/* INFO / SUCCESS / ERROR MODAL             */}
      {/* ========================================= */}

      {infoModal && (
        <div
          className="pm-del-overlay"
          onClick={() => setInfoModal(null)}
        >
          <div className="pm-del-box">

            <div
              className="pm-del-ico"
              style={{
                background:
                  infoModal.type === "success" ? "#f0fdf4"
                  : infoModal.type === "warn"   ? "#fefce8"
                  : "#fef2f2",
              }}
            >
              {infoModal.type === "success" && (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#22c55e" strokeWidth="2.5">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              )}
              {infoModal.type === "warn" && (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#eab308" strokeWidth="2.5">
                  <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
                  <line x1="12" y1="9" x2="12" y2="13"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
              )}
              {infoModal.type === "error" && (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#ef4444" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="15" y1="9" x2="9" y2="15"/>
                  <line x1="9" y1="9" x2="15" y2="15"/>
                </svg>
              )}
            </div>

            <div
              className="pm-del-title"
              style={{
                color:
                  infoModal.type === "success" ? "#166534"
                  : infoModal.type === "warn"   ? "#854d0e"
                  : "#991b1b",
              }}
            >
              {infoModal.msg}
            </div>

            <div className="pm-del-btns">
              <button
                className="pm-btn-ghost"
                onClick={() => setInfoModal(null)}
                type="button"
              >
                OK
              </button>
            </div>

          </div>
        </div>
      )}
    </div>
  );
}
